export function isObject(obj) {
  return typeof obj === 'object';
}

export function unwrapProperty(obj) {
  const keys = Object.keys(obj);
  if (keys.length !== 1) {
    throw Error(`Unwrapping object where number of properties unequal 1 not possible: ${JSON.stringify(obj)}`);
  }
  return obj[keys[0]];
}

export function firstKey(obj) {
  return Object.keys(obj)[0];
}

export function propertiesToURIQuery(params) {
  const queryString = Object.keys(params).reduce((p, c) => {
    let val = params[c];
    if (val === undefined) {
      return p;
    }
    if (isObject(val)) {
      val = encodeURIComponent(JSON.stringify(val));
    }
    const prefix = p ? `${p}&` : p;
    return `${prefix}${c}=${val}`;
  }, '');
  return (queryString);
}
